module.exports = __webpack_public_path__ + "img/Drew.15a13108.jpeg";